import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const AlertCircleIconV2 = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10 8C10.5523 8 11 8.44771 11 9V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V9C9 8.44771 9.44771 8 10 8Z"
          fill="#006DFF"
        />
        <path
          d="M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6C9 6.55228 9.44771 7 10 7Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10ZM18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);
export default AlertCircleIconV2;
